import * as $ from 'jquery';
import 'bootstrap';

export class helptopfaqs {
	private $faqs = $('.topfaq__accordion');

	initTopFaqs(): void {
		let _self = this;
		let panels:any = _self.$faqs.find('.topfaq__item');

		// toggle accordion icons (fontawesome classes) when expanding/collapsing
		// open: fa-plus
		// close: fa-minus
		for (var i=0, len=panels.length; i<len; i++) {
			let pIcon:any = panels[i].querySelector('.topfaq__toggle');
			let pBody:any = panels[i].querySelector('.panel-collapse');

			$(pBody).on('show.bs.collapse', function(){
				pIcon.classList.remove('fa-plus');
				pIcon.classList.add('fa-minus');
			});

			$(pBody).on('hide.bs.collapse', function(){
				pIcon.classList.remove('fa-minus');
				pIcon.classList.add('fa-plus');
			});
		}

	}
}

let scope:Element = document.querySelector('.topfaq__accordion');
if (scope){
	try {
	let helpTopFaqs = new helptopfaqs();
	helpTopFaqs.initTopFaqs();
	} catch(e) {console.error(e);}
}
